import { useState } from "react";
import type { FC } from "react";
import { Button } from "react-bootstrap";

import { AssignmentHistoryModal } from "components/Modal/AssignmentHistory";

import HistoryIcon from "images/icons/15-historie.svg";

interface Props {
  className?: string;
  assignmentId: string;
  userAssignmentId: string;
}

export const AssignmentHistoryButton: FC<Props> = ({ className, userAssignmentId, assignmentId }) => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleButtonClick = () => {
    if (!modalVisible) {
      setModalVisible(true);
    }
  };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Button
        variant={"select"}
        className={`btn-xl btn-shadow bookmark-button ${className ?? ""}`}
        onClick={handleButtonClick}
      >
        <HistoryIcon fill="none" />
      </Button>
      {modalVisible ? (
        <AssignmentHistoryModal
          userAssignmentId={userAssignmentId}
          assignmentId={assignmentId}
          onHide={handleModalClose}
        />
      ) : null}
    </>
  );
};
